import { TypeNameDictionary } from "types/cf-utils/types";
import { lazy } from "react";

// import BankSearch from "components/BankSearch";
// import CfBannerWrap from "components/BannerWrap/CfBannerWrap";
// import CfBoxLaunch from "components/BoxLaunch/CfBoxLaunch";
// import CfCard01 from "components/Cards/Card01/CfCard01";
// import CfCard02 from "components/Cards/Card02/CfCard02";
// import CfCard03 from "components/Cards/Card03/CfCard03";
// import Card04 from "components/Cards/Card04";
// import CfCard05 from "components/Cards/Card05/CfCard05";
// import CfCard06 from "components/Cards/Card06/CfCard06";
// import CfCard07 from "components/Cards/Card07/CfCard07";
// import CfCard08 from "components/Cards/Card08/CfCard08";
// import CfCardOffer from "components/Cards/CardOffer/CfCardOffer";
// import CfDoubleContentSlide from "components/DoubleContentSlide/CfDoubleContentSlide";
// import CfFileItem from "components/FileList/FileItem/CfFileItem";
// import CfFilterList from "components/FilterList/CfFilterList";
// import CfFormCustomDynamicFields from "components/FormCustomDynamicFields/CfFormCustomDynamicFields";
// import CfFormDynamicFields from "components/FormDynamicFields/CfFormDynamicFields";
// import CfFormField from "components/FormField/CfFormField";
// import CfHeroContent from "components/HeroContent/CfHeroContent";
// import CfHeroContentBlockSticky from "components/HeroContent/HeroContentBlockSticky/CfHeroContentBlockSticky";
// import CfHeroImage from "components/HeroImage/CfHeroImage";
// import CfInDepthImageAndContent from "components/InDepth/InDepthImageAndContent/CfInDepthImageAndContent";
// import CfSlider from "components/Slider/CfSlider";
// import CfTab from "components/Tab/CfTab";
// import CfTabStrip from "components/Tab/TabStrip/CfTabStrip";
// import CustomComponent from "components/CustomComponent";
// import FileList from "components/FileList";
// import MapTlpServices from "components/Maps";
// import SectionScrollAnimation from "components/SectionScrollAnimation";
// import Slide from "components/Slide";
import CfSms from "components/Sms/CfSms";

// const AccordionGroup = lazy(
//   () =>
//     import(
//       /* webpackChunkName: 'CF-ACCORDION-GROUP' */ "components/Accordion/AccordionGroup"
//     ),
// );
// const CfAccordionItem = lazy(
//   () =>
//     import(
//       /* webpackChunkName: 'CF-ACCORDION-ITEM' */ "components/Accordion/AccordionItem/CfAccordionItem"
//     ),
// );

// const CfBannerAdv = lazy(
//   () =>
//     import(
//       /* webpackChunkName: 'CF-BANNER-ADV' */ "components/Banner/BannerAdv/CfBannerAdv"
//     ),
// );
// const CfBannerDownloadApp = lazy(
//   () =>
//     import(
//       /* webpackChunkName: 'CF-BANNER-DOWNLOAD-APP' */ "components/BannerDownloadApp/CfBannerDownloadApp"
//     ),
// );

// const CfDoubleContent = lazy(
//   () =>
//     import(
//       /* webpackChunkName: 'CF-DOUBLE-CONTENT' */ "components/DoubleContent/CfDoubleContent"
//     ),
// );
// const CfDoubleContentBlock = lazy(
//   () =>
//     import(
//       /* webpackChunkName: 'CF-DOUBLE-CONTENT-BLOCK' */ "components/DoubleContent/DoubleContentBlock/CfDoubleContentBlock"
//     ),
// );

// const CfImage = lazy(
//   () => import(/* webpackChunkName: 'CF-IMAGE' */ "components/Image/CfImage"),
// );
// const CfImageIcon = lazy(
//   () =>
//     import(
//       /* webpackChunkName: 'CF-IMAGE-ICON' */ "components/ImageIcon/CfImageIcon"
//     ),
// );
// const CfList = lazy(
//   () => import(/* webpackChunkName: 'CF-LIST' */ "components/List/CfList"),
// );
// const CfSectionScrollItem = lazy(
//   () =>
//     import(
//       /* webpackChunkName: 'CF-SECTION-SCROLL-ITEM' */ "components/SectionScroll/SectionScrollItem/CfSectionScrollItem"
//     ),
// );
// const CfSeparator = lazy(
//   () =>
//     import(
//       /* webpackChunkName: 'CF-SEPARATOR' */ "components/Separator/CfSeparator"
//     ),
// );

// const CfText = lazy(
//   () => import(/* webpackChunkName: 'CF-TEXT' */ "components/Text/CfText"),
// );
// const CfVideo = lazy(
//   () => import(/* webpackChunkName: 'CF-VIDEO' */ "components/Video/CfVideo"),
// );
// const CtaContent = lazy(
//   () =>
//     import(/* webpackChunkName: 'CF-CTA-CONTENT' */ "components/CtaContent"),
// );
// const CtaList = lazy(
//   () => import(/* webpackChunkName: 'CF-CTA-LIST' */ "components/CtaList"),
// );
// const CtaReference = lazy(
//   () =>
//     import(
//       /* webpackChunkName: 'CF-CTA-REFERENCE' */ "components/CtaReference"
//     ),
// );

// const CustomHtml = lazy(
//   () =>
//     import(/* webpackChunkName: 'CF-CUSTOM-HTML' */ "components/CustomHtml"),
// );
// const FaqListPreview = lazy(
//   () =>
//     import(
//       /* webpackChunkName: 'CF-FAQ-LIST-PREVIEW' */ "components/FaqListPreview"
//     ),
// );

// const CfModal = lazy(
//   () => import(/* webpackChunkName: 'CF-MODAL' */ "components/Modal/CfModal"),
// );

// const Strip = lazy(
//   () => import(/* webpackChunkName: 'CF-STRIP' */ "components/Strip/StripWrap"),
// );

import CfAccordionGroup from "components/Accordion/AccordionGroup/CfAccordionGroup";
import CfAccordionItem from "components/Accordion/AccordionItem/CfAccordionItem";
import CfBannerAdv from "components/Banner/BannerAdv/CfBannerAdv";
import CfBannerDownloadApp from "components/BannerDownloadApp/CfBannerDownloadApp";
import CfDoubleContent from "components/DoubleContent/CfDoubleContent";
import CfDoubleContentBlock from "components/DoubleContent/DoubleContentBlock/CfDoubleContentBlock";
import CfEditorial from "components/Editorial/CfEditorial";
import CfHeroBanner from "components/HeroBanner/CfHeroBanner";
import CfHeroBlock from "components/HeroBlock/CfHeroBlock";
import CfImage from "components/Image/CfImage";
import CfImageIcon from "components/ImageIcon/CfImageIcon";
import CfList from "components/List/CfList";
import CfModal from "components/Modal/CfModal";
import CfOpenBanner from "components/OpenBanner/CfOpenBanner";
import CfSectionScrollItem from "components/SectionScroll/SectionScrollItem/CfSectionScrollItem";
import CfSeparator from "components/Separator/CfSeparator";
import CfText from "components/Text/CfText";
import CfVideo from "components/Video/CfVideo";
import CtaContent from "components/CtaContent";
import CtaList from "components/CtaList";
import CtaReference from "components/CtaReference";
import CustomComponent from "components/CustomComponent";
import CustomHtml from "components/CustomHtml";
import FaqListPreview from "components/FaqListPreview";
import Strip from "components/Strip/StripWrap";

const BankSearch = lazy(
  () =>
    import(/* webpackChunkName: 'CF-BANK-SEARCH' */ "components/BankSearch"),
);
const CfBannerWrap = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-BANNER-WRAP' */ "components/BannerWrap/CfBannerWrap"
    ),
);
const CfBoxLaunch = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-BOX-LAUNCH' */ "components/BoxLaunch/CfBoxLaunch"
    ),
);
const CfCard01 = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-01' */ "components/Cards/Card01/CfCard01"
    ),
);
const CfCard02 = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-02' */ "components/Cards/Card02/CfCard02"
    ),
);
const CfCard03 = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-03' */ "components/Cards/Card03/CfCard03"
    ),
);
const Card04 = lazy(
  () => import(/* webpackChunkName: 'CF-CARD-04' */ "components/Cards/Card04"),
);
const CfCard05 = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-05' */ "components/Cards/Card05/CfCard05"
    ),
);
const CfCard06 = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-06' */ "components/Cards/Card06/CfCard06"
    ),
);
const CfCard07 = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-07' */ "components/Cards/Card07/CfCard07"
    ),
);
const CfCard08 = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-08' */ "components/Cards/Card08/CfCard08"
    ),
);
const CfCard09 = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-09' */ "components/Cards/Card09/CfCard09"
    ),
);
const CfCardOffer = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-OFFER' */ "components/Cards/CardOffer/CfCardOffer"
    ),
);
const CfDoubleContentSlide = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-DOUBLE-CONTENT-SLIDE' */ "components/DoubleContentSlide/CfDoubleContentSlide"
    ),
);
const CfFileItem = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-FILE-ITEM' */ "components/FileList/FileItem/CfFileItem"
    ),
);
const CfFilterList = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-FILE-LIST' */ "components/FilterList/CfFilterList"
    ),
);
const CfFormCustomDynamicFields = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-FORM-CUSTOM-DYNAMIC-FIELDS' */ "components/FormCustomDynamicFields/CfFormCustomDynamicFields"
    ),
);
const CfFormDynamicFields = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-FORM-DYNAMIC-FIELDS' */ "components/FormDynamicFields/CfFormDynamicFields"
    ),
);
const CfFormField = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-FORM-FIELDS' */ "components/FormField/CfFormField"
    ),
);
const CfHeroContent = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-HERO-CONTENT' */ "components/HeroContent/CfHeroContent"
    ),
);
const CfHeroContentBlockSticky = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-HERO-CONTENT-BLOCK-STICKY' */ "components/HeroContent/HeroContentBlockSticky/CfHeroContentBlockSticky"
    ),
);
const CfHeroImage = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-HERO-IMAGE' */ "components/HeroImage/CfHeroImage"
    ),
);
const CfInDepthImageAndContent = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-INDEPTH-IMAGE-CONTENT' */ "components/InDepth/InDepthImageAndContent/CfInDepthImageAndContent"
    ),
);
const CfSlider = lazy(
  () =>
    import(/* webpackChunkName: 'CF-SLIDER' */ "components/Slider/CfSlider"),
);
const CfTab = lazy(
  () => import(/* webpackChunkName: 'CF-TAB' */ "components/Tab/CfTab"),
);
const CfTabStrip = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-TAB-STRIP' */ "components/Tab/TabStrip/CfTabStrip"
    ),
);
const FileList = lazy(
  () => import(/* webpackChunkName: 'CF-FILE-LIST' */ "components/FileList"),
);
const MapTlpServices = lazy(
  () => import(/* webpackChunkName: 'CF-MAP-TLP-SERVICE' */ "components/Maps"),
);
const SectionScrollAnimation = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-SECTION-SCROLL-ANIMATION' */ "components/SectionScrollAnimation"
    ),
);
const Slide = lazy(
  () => import(/* webpackChunkName: 'CF-SLIDE' */ "components/Slide"),
);

const CfHorizontalCarousel = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-HORIZONTAL-CAROUSEL' */ "components/HorizontalCarousel/CfHorizontalCarousel"
    ),
);

const CfCardGeneric = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-GENERIC' */ "components/Cards/CardGeneric/CfCardGeneric"
    ),
);

const CfCardIcon = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-ICON' */ "components/Cards/CardIcon/CfCardIcon"
    ),
);

const CfCardBgImage = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-BG-IMAGE' */ "components/Cards/CardBgImage/CfCardBgImage"
    ),
);

const CfGridRow = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-GRID-ROW' */ "components/GridRow/CfGridRow"
    ),
);

const CfTag = lazy(
  () => import(/* webpackChunkName: 'CF-TAG' */ "components/CfTag"),
);

const CfTagGroup = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-TAG-GROUP' */ "components/TagGroup/CfTagGroup"
    ),
);

const CfCardPromo = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-PROMO' */ "components/Cards/CardPromo/CfCardPromo"
    ),
);

const CfCardCart = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-CART' */ "components/Cards/CardCart/CfCardCart"
    ),
);

const CfMinimalStripContent = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-MINIMAL-STRIP-CONTENT' */ "components/MinimalStripContent/CfMinimalStripContent"
    ),
);

const CfStickyDoubleColumn = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-STICKY-DOUBLE-COLUMN' */ "components/StickyDoubleColumn/CfStickyDoubleColumn"
    ),
);

// TODO enable when usable on contentful
// const CfStickyElement = lazy(
//   () =>
//     import(
//       /* webpackChunkName: 'CF-STICKY-ELEMENT' */ "components/StickyElement/CfStickyElement"
//     ),
// );
const CfServiceCategory = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-SERVICE-CATEGORY' */ "components/ServiceCategory/CfServiceCategory"
    ),
);

const CfServicesGridFilter = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-SERVICES-GRID-FILTER' */ "components/ServicesGridFilter/CfServicesGridFilter"
    ),
);

const CfServiceCard = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-SERVICE-CARD' */ "components/ServiceCard/CfServiceCard"
    ),
);

const CfCardFullImage = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-CARD-FULL-IMAGE' */ "components/Cards/CardFullImage/CfCardFullImage"
    ),
);

const CfSliderCards = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-SLIDER-CARDS' */ "components/Cards/SliderCards/CfSliderCards"
    ),
);

const CfViewer3D = lazy(
  () =>
    import(
      /* webpackChunkName: 'CF-VIEWER-3D' */ "components/Viewer3D/CfViewer3D"
    ),
);

// const CfSms = lazy(
//   () => import(/* webpackChunkName: 'CF-SMS' */ "components/Sms/CfSms"),
// );

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dictionary: Record<TypeNameDictionary, React.FC<any>> = {
  ContentfulAccordionV2: CfAccordionGroup,
  ContentfulAccordionItemV2: CfAccordionItem,
  ContentfulBannerDownloadApp: CfBannerDownloadApp,
  ContentfulBannerAdvV2: CfBannerAdv,
  ContentfulCtaContentV2: CtaContent,
  ContentfulCtaListV2: CtaList,
  ContentfulCtaReferenceV2: CtaReference,
  ContentfulCustomHtmlV2: CustomHtml,
  ContentfulDoubleContentV2: CfDoubleContent,
  ContentfulDoubleContentBlockV2: CfDoubleContentBlock,
  ContentfulFaqListPreviewV2: FaqListPreview,
  ContentfulIconV2: CfImageIcon,
  ContentfulImageV2: CfImage,
  ContentfulListV2: CfList,
  ContentfulModalV2: CfModal,
  ContentfulStripV2: Strip,
  ContentfulTextV2: CfText,
  ContentfulVideoV2: CfVideo,
  ContentfulSeparatorV2: CfSeparator,
  ContentfulSectionScrollItemV2: CfSectionScrollItem,
  ContentfulSmsV2: CfSms,
  ContentfulHorizontalCarousel: CfHorizontalCarousel,
  ContentfulEditorial: CfEditorial,
  ContentfulOpenBanner: CfOpenBanner,
  ContentfulCustomComponentV2: CustomComponent,
  ContentfulHeroBlock: CfHeroBlock,
  ContentfulHeroBanner: CfHeroBanner,

  // dynamicly imported components
  ContentfulBankSearchV2: BankSearch,
  ContentfulBoxLaunchV2: CfBoxLaunch,
  ContentfulCard1V2: CfCard01,
  ContentfulCard2V2: CfCard02,
  ContentfulCard3V2: CfCard03,
  ContentfulCard4V2: Card04,
  ContentfulCard5V2: CfCard05,
  ContentfulCard6V2: CfCard06,
  ContentfulCard7V2: CfCard07,
  ContentfulCard8V2: CfCard08,
  ContentfulCard9: CfCard09,
  ContentfulCardOfferV2: CfCardOffer,
  ContentfulCardPromo: CfCardPromo,
  ContentfulCardCart: CfCardCart,
  ContentfulFormDynamicFieldsV2: CfFormDynamicFields,
  ContentfulFormCustomDynamicFields: CfFormCustomDynamicFields,
  ContentfulFormFieldV2: CfFormField,
  ContentfulDoubleContentSlideV2: CfDoubleContentSlide,
  ContentfulFileItemV2: CfFileItem,
  ContentfulFileListV2: FileList,
  ContentfulFilterListV2: CfFilterList,
  ContentfulHeroContentBlockStickyV2: CfHeroContentBlockSticky,
  ContentfulHeroContentV2: CfHeroContent,
  ContentfulHeroImageV2: CfHeroImage,
  ContentfulSliderSlideV2: Slide,
  ContentfulInDepthImageTextV2: CfInDepthImageAndContent,
  ContentfulMapTlpServicesV2: MapTlpServices,
  ContentfulMapTlpServicesLocatorV2: MapTlpServices,
  ContentfulSectionScrollV2: SectionScrollAnimation,
  ContentfulSliderV2: CfSlider,
  ContentfulTabV2: CfTab,
  ContentfulTabStripV2: CfTabStrip,
  ContentfulMapFilter: MapTlpServices,
  ContentfulBannerWrapV2: CfBannerWrap,
  ContentfulCardGeneric: CfCardGeneric,
  ContentfulCardIcon: CfCardIcon,
  ContentfulGridRow: CfGridRow,
  ContentfulCardBackgroundImage: CfCardBgImage,
  ContentfulTag: CfTag,
  ContentfulTagGroup: CfTagGroup,
  ContentfulServicesGridFilter: CfServicesGridFilter,
  ContentfulServiceCategory: CfServiceCategory,
  ContentfulServiceCard: CfServiceCard,
  ContentfulMinimalStripContent: CfMinimalStripContent,
  ContentfulStickyDoubleColumn: CfStickyDoubleColumn,
  ContentfulCardFullImage: CfCardFullImage,
  ContentfulSliderCards: CfSliderCards,
  ContentfulViewer3D: CfViewer3D,
};

export default dictionary;
